import { Button } from "../../../../components/ui/Button";
import { AnswerOptionId, AnswerOption } from "../../types/AnswerOption";

type SingleChoiceQuestionProps = {
  subtitle?: string;
  question: string;
  options: AnswerOption[];
  onSelect: (option: AnswerOptionId) => void;
  gift?: boolean;
};

export const SingleChoiceQuestion = ({
  subtitle,
  question,
  options,
  onSelect,
  gift,
}: SingleChoiceQuestionProps) => {
  return (
    <div
      className="flex flex-col w-full p-4 rounded-[2px] gap-6"
      style={{
        background: "rgba(59, 59, 59, 0.20)",
        backdropFilter: "blur(20px)",
      }}
    >
      <div className="flex flex-col gap-2 w-full items-center font-minion">
        <p className="text-[#FAF5F1] font-minion text-[14px] font-normal leading-[150%]">
          {subtitle}
        </p>
        <h1 className="text-white text-center font-minion text-[20px] font-normal">
          {!gift ? question.replace(/(her\/him)/gi, '') : question}
        </h1>
      </div>
      <div
        className={`grid ${
          options.length === 2 ? "grid-cols-1" : "grid-cols-2"
        } gap-[10px] w-full h-full`}
      >
        {options.map((option) => (
          <Button
            variant="answer"
            key={option.id}
            onClick={() => onSelect(option.id)}
          >
            <div className="flex flex-col h-10 justify-center items-center">
              <span className="text-[0.8rem] line-clamp-2 truncate">
                {option.label}
              </span>
              <span className="mt-[-3px] text-[0.6rem] truncate">
                {option.description}
              </span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};
